// extracted by mini-css-extract-plugin
export default {"container":"_2T6nHFN0GOBTC6RH027qnG","name":"iSPlR5IXywqA8tjyETTlb"};